import * as React from 'react';
import { useBOMStore } from 'src/hooks/bom';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const BomDeleteProjectPopup = (props) => {
    const { data, SetStatus } = props
    const [{ }, { fetch_bom_project_detail_with_bom }, { delete_project }] = useBOMStore();
    const onHide = () => {
        SetStatus(false)
    };
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const onDeleteProject = async () => {
        let projectId = data && data.projectId
        await delete_project({ projectId });
        onHide()
        await fetch_bom_project_detail_with_bom();
        system_alert_indicator({
            name: 'deleteBomProject',
            message: 'Your Project has been deleted.',
            type: "success"
        })
    };

    return (
        <>
            <div className="avnet-modal modal-600">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            onHide()
                        }}>×
                    </button>
                    <div className="modal-header border-0">
                        <h3 className="modal-title text-center m-auto" id="exampleModalLabel">Are you sure you want to
                            delete this project?</h3>
                    </div>
                    <div className="modal-body">
                        <div className="mt-0 mb-5 text-center"><b className='font-14'>This will also delete all the BOMs it contains.</b></div>
                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button type="button" className="bs5 btn btn-secondary w145"
                            onClick={() => {
                                onHide()
                            }}>cancel
                        </button>
                        <button type="button" className="bs5 btn btn-primary  w145"
                            onClick={() => onDeleteProject()}>delete project
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BomDeleteProjectPopup;